import React, { Component } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Textfield,
  IconButton,
} from 'react-mdl'
import Button from '../components/Button'

export default class Prompt extends Component {
  state = this.getInitalState(this.props)
  getInitalState({ inputs }) {
    if (inputs) {
      const initialValues = inputs
        .map(({ name, initialValue }) => [name, initialValue])
        .reduce((carry, [key, value]) => {
          carry[key] = value
          return carry
        }, {})
      return initialValues
    }
  }
  handleActionClick = action => () => {
    if (!this.props.inputs) {
      this.props.callback(action)
    } else {
      this.props.callback({
        action,
        output: this.state,
      })
    }
  }
  handleChange = ({ target }) => this.setState({ [target.name]: target.value })
  render() {
    const {
      title,
      ContentComponent,
      callback,
      message,
      inputs,
      options,
      style,
    } = this.props
    return (
      <Dialog style={style} open>
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>
          {ContentComponent
            ? <ContentComponent callback={callback} />
            : <div>
                <p>{message}</p>
                {inputs &&
                  inputs.map(input => (
                    <Textfield
                      floatingLabel
                      key={input.name}
                      value={this.state[input.name]}
                      name={input.name}
                      label={input.label}
                      type={input.type}
                      onChange={this.handleChange}
                    />
                  ))}
              </div>}
        </DialogContent>
        {options &&
          <DialogActions>
            {options.map(action => (
              <Button key={action} onClick={this.handleActionClick(action)}>
                {action}
              </Button>
            ))}
          </DialogActions>}
        <IconButton
          name="close"
          onClick={this.handleActionClick('cancel')}
          style={{ position: 'absolute', right: 0, top: 0 }}
        />
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Prompt.js